app.service("OrderHelper", ['$rootScope', function ($rootScope) {

    const helper = this;

    function requireOrder(order) {
        return order ? order : $rootScope.model.order.current_order;
    }

    this.cartQuantity = function (order) {
        order = requireOrder(order);
        let quantity = 0;

        for (let i = 0; i < order.lines.length; i++) {
            const line = order.lines[i];
            quantity += line.quantity ? parseInt(line.quantity) : 0
        }
        return quantity;
    }

    this.cart_linesAndSublines = function (order) {
        order = requireOrder(order);
        const lines = [];
        for (let i = 0; i < order.lines.length; i++) {
            const line = order.lines[i];
            lines.push(line);
            if (line._sublines) {
                for (let j = 0; j < line._sublines.length; j++) {
                    lines.push(line._sublines[j]);
                }
            }
        }
        return lines;
    }

    this.hasRigidItems = function (order) {
        const cartLines = helper.cart_linesAndSublines(order);
        for (let i = 0; i < cartLines.length; i++) {
            const line = cartLines[i];
            if (line.rigid) {
                return true;
            }
        }
        return false;
    }

    this.isIslandOfIrelandDelivery = function (order) {
        order = requireOrder(order);
        if (!order.delivery_address) {
            return false;
        }
        if (order.delivery_address.country && order.delivery_address.country.toUpperCase() === 'IE') {
            return true;
        }

        let postcode = order.delivery_address.postcode;
        postcode = postcode ? postcode.replace(/[^0-9A-Z]+/gi, "").toUpperCase() : "";
        postcode = postcode.substring(0, 2);
        return postcode === "BT";
    }

    this.removeCartLine = function (index, order) {
        order = requireOrder(order);
        order.lines.splice(index, 1);
        $rootScope.service.order.saveOrder(order);
    };

    this.addToCartLine = function (index, order) {
        order = requireOrder(order);
        const line = order.lines[index];
        line.quantity = line.quantity ? line.quantity : 1;
        line.quantity++;
        $rootScope.service.order.saveOrder(order);
    };

    this.subtractFromCartLine = function (index, order) {
        order = requireOrder(order);
        const line = order.lines[index];
        line.quantity = line.quantity ? line.quantity : 1;
        if (line.quantity === 1) {
            helper.removeCartLine(index)
            return;
        }
        line.quantity--;
        $rootScope.service.order.saveOrder(order);

    };

    this.isOrderSubmitted = function (order) {
        order = requireOrder(order);
        return order && order.type === "order";
    }

    this.isOrderWeb = function (order) {
        order = requireOrder(order);
        return order && order.type === "weborder";
    }

    this.isOrderQuote = function (order) {
        order = requireOrder(order);
        return order && order.type === "webquote";
    }

    this.recentBrowseRoute = function (order) {
        order = requireOrder(order);
        let routeOptions = null;
        const routeIDs = order.lines.length > 0 ? order.lines[0].state_ids : null
        if (routeIDs) {
            routeOptions = $rootScope.navigation_manager.createNavigationModel(null, routeIDs).route_options;
        }
        return routeOptions;
    }

    this.validateReference = function (order) {
        order = requireOrder(order);
        order.reference = order.reference ? order.reference.replace(/ /g, '-').replace(/#/g, '-').replace(/,/g, '-').replace(/\./g, '-') : "";
        return order.reference;
    }

    this.acknowledgementPdfURL = function (orderID) {
        return "/request/api-pdf.php/orders/" + orderID + "/acknowledgement.pdf?filename=order_acknowledgement_" + orderID
    }

    this.invoicePdfURL = function (orderID) {
        return "/request/api-pdf.php/orders/" + orderID + "/invoice.pdf?filename=order_invoice_" + orderID
    }

    this.orderPdfURL = function (orderID) {
        return "/request/api-pdf.php/orders/" + orderID + ".pdf";
    }
}]);